// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conference-page {
  display: block;
  position: relative;
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--navbar-height-player-page-mobile));
  height: calc(100svh - var(--navbar-height-player-page-mobile));
}
@media (min-width: 1200px) {
  .conference-page {
    height: calc(100vh - var(--navbar-height-player-page-desktop));
  }
}
.conference-page > *:last-child {
  flex: 1;
  display: flex;
}
.conference-page > *:last-child iframe {
  height: auto !important;
}
.conference-page__pre-meeting-text {
  font-size: 18px;
  text-align: center;
  padding: 20px;
}
@media (min-width: 1200px) {
  .conference-page__pre-meeting-text {
    padding: 30px;
  }
}
.conference-page__redirect-box {
  padding: 0 2rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/Conference/Conference.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EAEA,6DAAA;EACA,8DAAA;AAFJ;AAII;EATJ;IAUQ,8DAAA;EADN;AACF;AAGI;EACI,OAAA;EACA,aAAA;AADR;AAGQ;EACI,uBAAA;AADZ;AAKI;EACI,eAAA;EACA,kBAAA;EACA,aAAA;AAHR;AAKQ;EALJ;IAMQ,aAAA;EAFV;AACF;AAKI;EACI,eAAA;AAHR","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
